import cn from 'classnames';
import { ErrorBoundary } from 'react-error-boundary';
import { useSuspenseNetworkQuery } from '#api/networks.queries.ts';
import { Link } from '#components/atoms/link/Link.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { makeFallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';

type Props = { networkId: string; className?: string };

/**
 * Renders a link to a network page, fetching its name to show
 */
export function NetworkLink(props: Props) {
  return (
    <ErrorBoundary fallbackRender={makeFallbackRenderNotFound(<span className="truncate">{props.networkId}</span>)}>
      <InnerNetworkLink {...props} />
    </ErrorBoundary>
  );
}

function InnerNetworkLink({ networkId, className }: Props) {
  const location = useAppLocation();
  const { data: network } = useSuspenseNetworkQuery(networkId).data;

  return (
    <Link to={`/settings/networks/${networkId}`} state={{ from: location }} className={cn('a', className)}>
      {network.name}
    </Link>
  );
}
